interface DATE_FORMAT_TYPE {
  long: string;
  short: string;
  shorts: string[];
}

interface DATE_FORMATS_TYPE {
  [index: string]: DATE_FORMAT_TYPE;
}

export const DATE_FORMATS: DATE_FORMATS_TYPE = {
  "MM/DD/YYYY": {
    long: "MMM d, yyyy",
    short: "MM/dd/yyyy",
    shorts: [
      "MM/dd/yyyy",
      "M/d/yyyy",
      "MM/d/yyyy",
      "M/dd/yyyy",
      "MM/dd/yy",
      "M/d/yy",
      "MM/d/yy",
      "M/dd/yy",
    ],
  },
  "DD/MM/YYYY": {
    long: "d MMM yyyy",
    short: "dd/MM/yyyy",
    shorts: [
      "dd/MM/yyyy",
      "d/M/yyyy",
      "d/MM/yyyy",
      "dd/M/yyyy",
      "dd/MM/yy",
      "d/M/yy",
      "d/MM/yy",
      "dd/M/yy",
    ],
  },
  "YYYY-MM-DD": {
    long: "yyyy-MM-dd",
    short: "yyyy-MM-dd",
    shorts: [
      "yyyy-MM-dd",
      "yyyy-M-d",
      "yyyy-MM-d",
      "yyyy-M-dd",
      "yy-MM-dd",
      "yy-M-d",
      "yy-MM-d",
      "yy-M-dd",
    ],
  },
};
